import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MainButtonContainer = styled.div({
	alignItems: 'center',
	display: 'flex',
	paddingRight: token('space.300'),
	flexShrink: 0,
	position: 'relative',
	zIndex: 602 /* above FullPageEditor.spinner */,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SubsequentNodeWrapper = styled.div({
	marginLeft: token('space.050'),
});
